module.exports = __webpack_public_path__ + "img/blue-dash.211f73d2.svg";